App.Models.districtEmotion = class DistrictEmotion extends PF.Model {

    get populateExceptions() {
        return {
            border: true
        };
    }
}